<script setup>
</script>

<template> 

    <nav-bar/>

    <main-container :onlyNav="true" class="text-justify px-5">
        <div>
            <h1>Declaração de Privacidade</h1>
            <p>A <a href="https://fourlions.com.br/">FourLions Tecnologia</a> é a entidade responsável pelo tratamento dos seus dados pessoais.</p>
            <p>A sua privacidade é importante para nós. É política do PsicoApp respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar em nosso site ou aplicativo. Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez não possamos fornecer alguns dos serviços desejados.</p>
            <br/>            

            <h3>Coleta de dados e segurança</h3>
            <p>O PsicoApp recebe e armazena dados sobre você, tais como:</p>
            <ul>
                <li>
                    <p>
                        <strong>Dados fornecidos por você:</strong>
                    </p>
                </li>
                <ul>
                    <li>seu nome, numéro de celular, email, relatos, humor. Solicitamos informações pessoais apenas quando realmente precisamos delas para prestar nosso serviço. Fazemos por meios justos, legais e seguros, sempre com o seu conhecimento e consentimento.</li>
                    <br>
                    <li>apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solicitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados.</li>     
                    <br>
                    <li>pacientes podem a qualquer momento manipular e ou excluir relatos criados por sí mesmo, porem, não é possível excluir sua propria conta devido ao tratamento estabelecido pelo profissional responável.</li>                         
                </ul>
                <br/>                                               
            </ul>                        
            <br/>            

            <h3>Uso e tratamento de dados</h3>
            <p>Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei.</p>
            <p>Todos os relatos são mantidos total sigilo em hipotese alguma são divididos com outras pessoas, execeto ao profissional da saúde com quem você está trabalhando</p>
            <ul>
                <li>
                    <p>
                        <strong>Os dados coletados que dizem respeito ao acompanhamento clínico do paciente:</strong>
                    </p>
                </li>                
                <ul>
                    <li>estão disponíveis apenas para os respectivos profissionais, a fim de fornecer indicativos e relatórios sobre a efetividade da abordagem do acompanhamento.</li>
                        <br>
                    <li>estão devidamente protegidos com criptografia e restritos somente ao próprio paciente e o respectivo profissional responsável. Nem mesmo o PsicoApp pode ler o conteúdo dos relatos.</li>
                </ul>                                
            </ul>   
            <br/>    
            
            <h3>Tipo de dados</h3>
            <p>Troca de informações entre profissional e paciente em forma de relatos e indicadores que ilustram o humor do paciente par que seu acompanhamento tenha um melhor aproveitamento.</p>
               
            <br/>  
                                                
            <h3>Acesso ao PsicoApp</h3>
            <p>Poderão se cadastrar na plataforma:</p> 
            <ul>
                <li><strong>Psicólogos:</strong> Profissionais devidamente registrados Conselho Regional de Psicologia (CRP) de sua região (integrante do Sistema Conselhos do Conselho Federal de Psicologia - CFP).</li>
                <br>
                <li><strong>Pacientes:</strong> Pessoas físicas que se cadastram na Plataforma a pedido do profissional da saúde para receber acompanhamento mediante a seus relatos.</li>
            </ul>
            <br/>
            
            <h3>Alterações na atual Declaração de privacidade</h3>
            <p>
                O PsicoApp poderá periodicamente alterar esta Declaração de privacidade a fim de acompanhar mudanças na legislação, exigências operacionais e ou regulatórias. Alterações serão comunicadas (inclusive a data em que entrarão em vigor) conforme previsto por lei. O uso continuado do serviço PsicoApp será considerado como aceitação de nossas práticas em torno de privacidade e informações pessoais.
            </p>
            <br>

            <p><strong>Última atualização:</strong> 28º de Fevereiro de 2024</p>

        </div>        
    </main-container>
</template>

<style lang="css" scoped>    
    ul{
        list-style: disc;
    }

</style>
